import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";

import gql from "graphql-tag";
import moment from "moment";

const ADD_HOSTEL_ATTENDANCE = gql`
  mutation($params: AddHostelAttendance) {
    addHostelAttendance(params: $params)
  }
`;

class SubmitHostelAttendanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      submitError: "",
      loadingSpinner: 0,
    };
  }

  handleFormSubmit = (e) => {

    e.preventDefault();

    let studentDetails = [];
    this.props.stateData.capacityDetails.map((item) => {
      studentDetails.push({ edu_student_id: item.edu_student_id, attendance_status: parseInt(item.attendance_status), room_id: parseInt(item.roomSearch) })
      console.log("item123", studentDetails);
    })

    let roomSearch = this.props.stateData.capacityDetails.some((item) => item.edu_student_id == studentDetails.edu_student_id)
    console.log(("roomSearch", roomSearch));

    let params = {
      room_id: this.props.stateData.capacityDetails.map((item) => item.roomSearch).toString(),
      attended_date: moment(this.props.stateData.date, 'YYYY-MM-DD').unix().toString(),
      inserted_by: parseInt(Cookies.get("id")),
      hostel_attendance: studentDetails
    };
    console.log("params", params);

    this.setState({ loadingSpinner: 1 })

    this.addHostelAttendance(params).catch(error => {
      console.log("catch if error");
      console.log(error);
      this.setState({
        submitError: error.graphQLErrors.map(x => x.message),
        loadingSpinner: 0
      });
      console.error(
        "ERR =>",
        error.graphQLErrors.map(x => x.message)
      );
    });

  }


  addHostelAttendance = async params => {
    console.log("child");
    await this.props.addHostelAttendance({
      variables: {
        params
      },
      update: (store, { data }) => {
        console.log("data", data);
        if (data.addHostelAttendance) {
          this.setState({
            currentStep: 5,
            loadingSpinner: 0
          });
          setTimeout(() => {
            this.SetpageLoad();
          }, 1000);
        }
      }
    });
  };

  SetpageLoad = () => {
    window.location.reload(false);
    this.setState({ currentStep: 1, submitError: "" });
    this.props.onHide();
  };


  render() {
    console.log("props", this.props);
    return (
      <Modal
        {...this.props}
        size="md"
        aria-labelledby="example-modal-sizes-title-lg"

      >
        <Modal.Header closeButton>
          <Modal.Title>Hotel Attendance confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col>
              <h4>Total Students :</h4>
            </Col>
            <Col>
              <h4>{this.props.stateData.totalStudents}</h4>
            </Col>
          </Row>
          <Row>
            <Col>
              <h6>Total Present :</h6>
            </Col>
            <Col>
              <h6>{this.props.stateData.presentStudents}</h6>
            </Col>
          </Row>
          <Row>
            <Col>
              <h6>Total Absent :</h6>
            </Col>
            <Col>
              <h6>{this.props.stateData.absentStudents} </h6>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer variant="white" className="px-4">
          <Row>
            <Col sm={12}>
              {this.state.currentStep == 5 ? (
                <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                  Attendance added successfully
                </Form.Text>
              ) : (
                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center", display: "none" }}>
                  {this.state.submitError}
                </Form.Text>
              )}
            </Col>
          </Row>
          <Row>
            <Col sm={12} >

              <Button onClick={this.handleFormSubmit} style={{ backgroundColor: "#213046", border: "1px solid #213046" }} type="submit" inline>
                {
                  this.state.loadingSpinner == 1 ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : ""
                }
                CONFIRM</Button>

            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    )
  }
}
export default graphql(ADD_HOSTEL_ATTENDANCE, {
  name: "addHostelAttendance"
})(SubmitHostelAttendanceModal);